import {StartDownload, StartUpload} from "js-vextensions";
import {Filesystem, Directory} from "@capacitor/filesystem";
import {Share} from "@capacitor/share";
import {InAndroid} from "../Bridge/Bridge_Native.js";

export async function StartDownload_Generic(content: string | Blob, filename: string) {
	if (InAndroid(0)) {
		return await StartDownload_Android(content, filename, true);
	}
	return await StartDownload(content, filename);
}

export async function StartDownload_Android(content: string | Blob, filename: string, showShareDialog = false) {
	// convert to base64
	let base64Data: string;
	if (content instanceof Blob) {
		base64Data = await blobToBase64(content);
	} else {
		base64Data = btoa(content);
	}

	// write file to device
	const result = await Filesystem.writeFile({
		path: filename,
		data: base64Data,
		directory: Directory.Documents,
	});

	// Optionally share the file or show success message
	console.log("File saved:", result.uri);

	if (showShareDialog) {
		// You can also trigger the share dialog
		await Share.share({
			title: "Download complete",
			text: `Saved to: ${filename}`,
			url: result.uri,
		});
	}
}

function blobToBase64(blob: Blob): Promise<string> {
	return new Promise((resolve, reject)=>{
		const reader = new FileReader();
		reader.onloadend = ()=>{
			const base64 = (reader.result as string).split(",")[1];
			resolve(base64);
		};
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
}